import FatalError from "ui/components/fatal-error/FatalError";
import {i18n} from "ui/i18n";

/**
 * @typedef {object} T_SseOptions
 * @property {string} url
 * @property {object<string,function(data:*):void>} events
 */

export default class Sse {
	/**
	 * @param {T_SseOptions} options
	 */
	constructor(options) {
		/**
		 * @type {T_SseOptions}
		 * @private
		 */
		this._options = options;

		/**
		 * @type {EventSource|null}
		 * @private
		 */
		this._src = null;
	}

	/**
	 * @return {Promise<any>}
	 */
	async load() {
		let result = null;
		return new Promise((resolve, reject) => {
			this.close();
			this._src = new EventSource(this._options.url);

			this._src.onerror = (e) => {
				this.close();
				FatalError.show(i18n('errors.http.error'));
				reject();
			};

			for (const [event, handler] of Object.entries(this._options.events)) {
				this._src.addEventListener(event, (e) => {
					handler(JSON.parse(e.data));
				});
			}

			this._src.addEventListener('debug', (e) => {
				console.log('SSE:', JSON.parse(e.data));
			});

			this._src.addEventListener('error', (e) => {
				console.error('SSE:', JSON.parse(e.data));
			});

			this._src.addEventListener('result', (e) => {
				result = JSON.parse(e.data);
			});

			this._src.addEventListener('close', (e) => {
				this.close();
				resolve(result);
			});
		});

	}

	close() {
		if (!this._src || this._src.readyState === EventSource.CLOSED) {
			return;
		}

		this._src.close();
		this._src = null;
	}
}
